import React, { FC } from "react";
import { Checkbox, Modal, Typography } from "antd";
import { PromoType } from "../promo-types";

type PromoExportModalProps = {
	isOpen: boolean;
	typeFilter?: PromoType;
	includeDistribution: boolean;
	setIncludeDistribution: (checked: boolean) => void;
	exportPromos: () => void;
	closePromoExportModal: () => void;
};

const PromoExportModal: FC<PromoExportModalProps> = ({
	isOpen,
	typeFilter,
	includeDistribution,
	setIncludeDistribution,
	exportPromos,
	closePromoExportModal,
}) => (
	<Modal
		centered
		open={isOpen}
		onOk={exportPromos}
		onCancel={closePromoExportModal}
		okText="Export"
		title="Export Promos"
		maskClosable={false}
		width={400}
	>
		<Typography.Paragraph>
			{typeFilter ? `Exporting ${typeFilter} promos only.` : "Exporting all promo types."}
		</Typography.Paragraph>
		<Checkbox checked={includeDistribution} onChange={e => setIncludeDistribution(e.target.checked)}>
			Include Distribution
		</Checkbox>
	</Modal>
);

export default PromoExportModal;
